<template>
	<div>
		<ly-condition v-ref:conditions title="指定时间" :datetime="datetime" withbtn="no" ctitle="指定时间段"></ly-condition>
		<ly-search>
			<div slot="s1" class="mb10 tie-4 mr60">
				<label class="tie-f control-label tr c-grey pr20">门店名称</label>
				<div class="tie-s">
			    	<input type="text" class="form-control" placeholder="请输入门店名称" v-model="formdata.shop_name">
				</div>
			</div>
			<div slot="s2" class="mb10 tie-4 mr60">
				<label class="tie-f control-label tr c-grey pr20">BD姓名：</label>
				<div class="tie-s">
			    	<input type="text" class="form-control" placeholder="请输入姓名" v-model="formdata.bd_name">
				</div>
			</div>
		</ly-search>
		<ly-datalist url="shopInfo" :formdata="formdata" :datetime="datetime" ex="yes" add="yes" addtxt="导出当前筛选结果">
			<table class="table">
		        <thead>
		          <tr>
		            <th>门店名称</th>
		            <th>所属管理公司</th>
		            <th>所属BD</th>
		            <th>工单开单数</th>
		            <th>日均工单数</th>
		            <th>总客户数</th>
		            <th>会员客户总数</th>
		            <th>商品SKU数量</th>
		            <th>服务SKU数量</th>
		          </tr>
		        </thead>
		        <tbody>
		        	<tr v-for="item in data">
			            <td style="white-space:pre">{{item.shop_name}}</td>
			            <td style="white-space:pre">{{item.company_name}}</td>
			            <td style="white-space:pre">{{item.bd_name}}</td>
			            <td>{{item.work_count}}</td>
			            <td>{{item.work_avg_count}}</td>
			            <td>{{item.customer_count}}</td>			           
			            <td>{{item.vip_count}}</td>			           
			            <td>{{item.product_num}}</td>			           
			            <td>{{item.service_num}}</td>
			        </tr>
		        </tbody>
		    </table>
		</ly-datalist>
	</div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js'); 
	var Comm = require('../utils/Common.js');
	//条件的获取
	var getCondition = function(vm) {
		var data = vm.$refs.conditions.cond;	
		vm.datetime.date_start = data[0];
		vm.datetime.date_end = data[1];
	};
	//标准日期格式转换
	var getLocalTime = function(s){
		var curDate = new Date();
		var date_start = curDate.getFullYear() + '-' + (curDate.getMonth() + 1) + '-' + curDate.getDate();
		var tomDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
		var date_end = tomDate.getFullYear() + '-' + (tomDate.getMonth() + 1) + '-' + tomDate.getDate();
		return {
			date_start: date_start,
			date_end: date_end
		};
	};
	/**
	* 组件对象
	*/
	var Component = {
		data : function(){
			return {
				data : [],
				formdata: {
					shop_name: "",
					bd_name: ""
				},
				//上传数据--时间
				datetime: {
					date_start: getLocalTime().date_start,
					date_end: getLocalTime().date_end
				},

			}
		},
		ready: function(){
		},
		components :  {
			'ly-datalist' : require('../components/Datalist.vue'),
			'ly-condition' : require('../components/Condition.vue'),
			'ly-search' : require('../components/Search.vue'),
		},
		events : {
			datalist : function(data){
				this.data = data;
			},
			submit: function() {
				//调用上面的条件筛选方法
				getCondition(this);
				this.$broadcast('submit');
			},
			/**
			 * 导出
			 */
			doExport: function() {
				getCondition(this);
				var data = {
					ticket: 'shopInfo'
				};
				if(this.datetime) {
					console.log('datatime');
					Comm.propertyToObj(data,this.datetime);//将datetime的属性赋给data
				}
				if(this.formdata) {
					Comm.propertyToObj(data,this.formdata);//将formdata的属性赋给data
				}
				Comm.confirm("门店指标统计导出完成，点击“确定”下载导出结果", function() {
					Http['export'].query({
						data: data,
						succ: function(rs) {
							window.open(rs.url);
						},
						err: function(msg) {
							Comm.tipDialog(msg,1500,"error");
						}
					})
				});
			}
		}
	};
	module.exports = Component;
</script>


/** WEBPACK FOOTER **
 ** shop_account.vue?3b1ce62d
 **/